module.exports = __webpack_public_path__ + "img/fluid-wagon-shadow-3.e8a843d5.png";